export const BLE_Devices = [
    'MatrixIQ',
    'Vital'
]

export function isBLETracker(value: any) {

    // e.g. device health: details map markers
    if (typeof value === 'string') {
        return BLE_Devices.includes(value);
    }
    
    if (value?.devices?.length > 0) {
        return value.devices.some((d: any) => BLE_Devices.includes(d.name) || BLE_Devices.includes(d.deviceType?.name));
    }

    return false;
}